import { createFileRoute } from '@tanstack/react-router'
import { ResellerCustomersPage } from '@/features/reseller/customers/pages/reseller-customers-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/reseller/customers')({
  beforeLoad: requireRole(['reseller', 'admin']),
  component: () => <ResellerCustomersPage />,
})

